// removed by extract-text-webpack-plugin
module.exports = {"theme":"#3197FF"};


//////////////////
// WEBPACK FOOTER
// ./src/user/styles/element-variables.scss
// module id = YCTG
// module chunks = 12